// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__xXkTW","text":"SelectPayment_text__1z_lp","title":"SelectPayment_title__5zCyp","btn":"SelectPayment_btn__kwgpH"};